;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var Model = APP.module('Model');

	Model.AccountBuilder = Backbone.Model.extend({
		defaults: {
			widgets: [ 'MenuSideBar','Promo'],
			form_templates: '',
			regions: [
				{ id: 'account', name: 'Your details', url: 'account'},
				{ id: 'changePassword', name: 'Change Password', url: 'account/change_password'},
				{ id: 'notifications', name: 'Notifications', url: 'account/notifications'},
				{ id: 'socialConnections', name: 'Social Connections', url: 'account/social_connections'}
			],
			menuItems: [
				{ name: 'Your details', url: 'account', status: ''},
				{ name: 'Change Password', url: 'account/change_password', status: ''},
				{ name: 'Notifications', url: 'account/notifications', status: ''},
				{ name: 'Social Connections', url: 'account/social_connections', status: ''}
			],
			your_details_fields: 'avatar,team_name,team_supported,first_name,last_name,email,birthday,cbus_id,mobile',
			notification_fields : {
				global: 'disable_notifications',
				others: 'news,weekly_results,weekly_reminders'
			},
			socialConnect: {
				facebook: true,
				twitter: false
			}
		},
		initialize: function(){
			this.setCustomInit();
			this.setActiveState();
		},
		setActiveState: function(){
			var current_url = Backbone.history.fragment,
				currentMenuItems = this.get('menuItems');
			_.each(currentMenuItems, function(value, key){
				value.status = '';
				if(current_url == value.url){
					currentMenuItems[key].status = 'active'
				}
			});
			this.set('menuItems',currentMenuItems );
		},
		setCustomInit: function(){
			return this;
		}
	});

}(window, APP, Backbone, Marionette, $, _));
